/** Crisp, circular flag marks for the language switch. Pure SVG – no emoji, no external assets. */

const Round = ({ children, className = "h-5 w-5", title }) => (
  <span className={`relative inline-flex shrink-0 overflow-hidden rounded-full ring-1 ring-black/10 ${className}`} role="img" aria-label={title}>
    {children}
  </span>
);

export const FlagNO = ({ className, title = "Norsk" }) => (
  <Round className={className} title={title}>
    <svg viewBox="0 0 22 16" preserveAspectRatio="xMidYMid slice" className="h-full w-full" aria-hidden>
      <rect width="22" height="16" fill="#BA0C2F" />
      <rect x="6" width="4" height="16" fill="#FFFFFF" />
      <rect y="6" width="22" height="4" fill="#FFFFFF" />
      <rect x="7" width="2" height="16" fill="#00205B" />
      <rect y="7" width="22" height="2" fill="#00205B" />
    </svg>
  </Round>
);

export const FlagGB = ({ className, title = "English" }) => (
  <Round className={className} title={title}>
    <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" className="h-full w-full" aria-hidden>
      <clipPath id="ffh-gb-clip"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" /></clipPath>
      <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#FFFFFF" strokeWidth="6" />
      <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#ffh-gb-clip)" stroke="#C8102E" strokeWidth="4" />
      <path d="M30,0 v30 M0,15 h60" stroke="#FFFFFF" strokeWidth="10" />
      <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
    </svg>
  </Round>
);

export const LANGS = [
  { code: "nn", short: "NN", label: "Nynorsk", Flag: FlagNO },
  { code: "en", short: "EN", label: "English", Flag: FlagGB },
];

export const Flag = ({ code, className }) => {
  const l = LANGS.find((x) => x.code === code) || LANGS[0];
  return <l.Flag className={className} title={l.label} />;
};
